
















import type {PeriodeMetOpdrachten} from "../../types/opdrachten/PeriodeMetOpdrachten";

import Vue from "vue";
import PeriodeMetOpdrachtenView from "./PeriodeMetOpdrachtenView.vue";

export default Vue.extend({
  name: "PeriodesMetOpdrachten",
  components: {
    PeriodeMetOpdrachtenView,
  },
  props: {
    periodesMetOpdrachten: {
      type: Array as () => PeriodeMetOpdrachten[],
      required: true,
      default: []
    },
  },
})
